export const gmapMixin = {
	data() {
	},
	computed: {
		
	},
  methods: {

      
  } 
};


// WEBPACK FOOTER //
// ./src/mixins/gmapMixin.js